// extracted by mini-css-extract-plugin
module.exports = {"link":"Swatch_link__PsBjP","option":"Swatch_option__8J_js","notAvailable":"Swatch_notAvailable___q6s5","selected":"Swatch_selected__xTqVD"};